import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ICheckBuilder from "../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";

export type Inputs = "limiteUsuarios" | "monto" | "sinLimite" | "limiteDesde";
export type Buttons = "aceptar" | "cancelar";

// Función para crear el config dinámicamente
export const formConfigFactory = (
  tipoComision: "PORCENTAJE" | "MONETARIO"
): FormBuilderConfig<Inputs, Buttons> => ({
  inputs: [
    {
      name: "limiteDesde",
      label: "Desde",
      bts: { mCol: 4 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        disabled: true // Siempre deshabilitado, se calcula automáticamente
      }
    },
    {
      name: "limiteUsuarios",
      label: "Hasta",
      bts: { mCol: 4 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        hidden: formValue => formValue.sinLimite === true
      }
    },
    {
      name: "sinLimite",
      label: "Sin límite",
      bts: { mCol: 4 },
      component: ICheckBuilder
    },
    {
      name: "monto",
      label:
        tipoComision === "PORCENTAJE"
          ? "Descuento (porcentaje)"
          : "Descuento (monto)",
      bts: { mCol: 12 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC"
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Guardar",
      isSubmit: true,
      bts: {
        mOff: 6,
        mCol: 3
      },
      component: IButtonBuilder,
      props: {}
    },
    {
      name: "cancelar",
      label: "Cancelar",
      isSubmit: false,
      bts: {
        mCol: 3
      },
      component: IButtonBuilder
    }
  ],
  validations: {
    limiteUsuarios: {
      requiredIfConLimite: {
        validator: (value, formValue) => !formValue.sinLimite && !Number(value),
        message: () => "Ingrese un límite",
        partners: ["sinLimite"]
      },
      minNumber: 1,
      maxNumber: 10000
    },
    monto: {
      required: true,
      minMonto: {
        validator: value => {
          const numValue = parseFloat(value);
          return numValue === 0;
        },
        message: () => "La comisión no puede ser 0"
      },
      maxMontoPorcentaje: {
        validator: value => {
          const numValue = parseFloat(value);
          return numValue > 100 && tipoComision === "PORCENTAJE";
        },
        message: () => "La comisión no puede ser mayor a 100%"
      }
    }
  },
  rows: [
    ["limiteDesde", "limiteUsuarios", "sinLimite"],
    ["monto"],
    ["aceptar", "cancelar"]
  ]
});
